module.exports = __webpack_public_path__ + "media/images/games-91298834af73e9b96cad354fba64c999.png";